import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({ title, subtitle, moreTo, moreLabel = '查看更多' }: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1.5 rounded-full bg-accent-500" />
        <div>
          <h2 className="text-xl font-bold text-foreground-950 font-heading md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}